export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14596.2d8d5734.jpg";